/**
 * currencies.js — Complete list of world currencies with codes, names, and symbols.
 * Default currency: USD ($).
 *
 * Usage:
 *   import { CURRENCIES, getCurrencyDisplay, DEFAULT_CURRENCY } from '../utils/currencies';
 *
 *   getCurrencyDisplay('INR') → '₹'
 *   getCurrencyDisplay('USD') → '$'
 *   getCurrencyDisplay('XYZ') → 'XYZ'   (fallback to code)
 */

export const DEFAULT_CURRENCY = 'USD';

/** Full list of ~180 world currencies */
export const CURRENCIES = [
  { code: 'AED', name: 'UAE Dirham',                     symbol: 'د.إ' },
  { code: 'AFN', name: 'Afghan Afghani',                 symbol: '؋'   },
  { code: 'ALL', name: 'Albanian Lek',                   symbol: 'L'   },
  { code: 'AMD', name: 'Armenian Dram',                  symbol: '֏'   },
  { code: 'ANG', name: 'Netherlands Antillean Guilder',  symbol: 'ƒ'   },
  { code: 'AOA', name: 'Angolan Kwanza',                 symbol: 'Kz'  },
  { code: 'ARS', name: 'Argentine Peso',                 symbol: '$'   },
  { code: 'AUD', name: 'Australian Dollar',              symbol: 'A$'  },
  { code: 'AWG', name: 'Aruban Florin',                  symbol: 'ƒ'   },
  { code: 'AZN', name: 'Azerbaijani Manat',              symbol: '₼'   },
  { code: 'BAM', name: 'Bosnia-Herzegovina Convertible Mark', symbol: 'KM' },
  { code: 'BBD', name: 'Barbadian Dollar',               symbol: 'Bds$'},
  { code: 'BDT', name: 'Bangladeshi Taka',               symbol: '৳'   },
  { code: 'BGN', name: 'Bulgarian Lev',                  symbol: 'лв'  },
  { code: 'BHD', name: 'Bahraini Dinar',                 symbol: 'BD'  },
  { code: 'BIF', name: 'Burundian Franc',                symbol: 'Fr'  },
  { code: 'BMD', name: 'Bermudan Dollar',                symbol: '$'   },
  { code: 'BND', name: 'Brunei Dollar',                  symbol: 'B$'  },
  { code: 'BOB', name: 'Bolivian Boliviano',             symbol: 'Bs.' },
  { code: 'BRL', name: 'Brazilian Real',                 symbol: 'R$'  },
  { code: 'BSD', name: 'Bahamian Dollar',                symbol: 'B$'  },
  { code: 'BTN', name: 'Bhutanese Ngultrum',             symbol: 'Nu'  },
  { code: 'BWP', name: 'Botswanan Pula',                 symbol: 'P'   },
  { code: 'BYN', name: 'Belarusian Ruble',               symbol: 'Br'  },
  { code: 'BZD', name: 'Belize Dollar',                  symbol: 'BZ$' },
  { code: 'CAD', name: 'Canadian Dollar',                symbol: 'CA$' },
  { code: 'CDF', name: 'Congolese Franc',                symbol: 'FC'  },
  { code: 'CHF', name: 'Swiss Franc',                    symbol: 'CHF' },
  { code: 'CLP', name: 'Chilean Peso',                   symbol: '$'   },
  { code: 'CNY', name: 'Chinese Yuan',                   symbol: '¥'   },
  { code: 'COP', name: 'Colombian Peso',                 symbol: '$'   },
  { code: 'CRC', name: 'Costa Rican Colón',              symbol: '₡'   },
  { code: 'CUC', name: 'Cuban Convertible Peso',         symbol: '$'   },
  { code: 'CUP', name: 'Cuban Peso',                     symbol: '₱'   },
  { code: 'CVE', name: 'Cape Verdean Escudo',            symbol: '$'   },
  { code: 'CZK', name: 'Czech Koruna',                   symbol: 'Kč'  },
  { code: 'DJF', name: 'Djiboutian Franc',               symbol: 'Fr'  },
  { code: 'DKK', name: 'Danish Krone',                   symbol: 'kr'  },
  { code: 'DOP', name: 'Dominican Peso',                 symbol: 'RD$' },
  { code: 'DZD', name: 'Algerian Dinar',                 symbol: 'دج'  },
  { code: 'EGP', name: 'Egyptian Pound',                 symbol: '£'   },
  { code: 'ERN', name: 'Eritrean Nakfa',                 symbol: 'Nfk' },
  { code: 'ETB', name: 'Ethiopian Birr',                 symbol: 'Br'  },
  { code: 'EUR', name: 'Euro',                           symbol: '€'   },
  { code: 'FJD', name: 'Fijian Dollar',                  symbol: 'FJ$' },
  { code: 'FKP', name: 'Falkland Islands Pound',         symbol: '£'   },
  { code: 'GBP', name: 'British Pound',                  symbol: '£'   },
  { code: 'GEL', name: 'Georgian Lari',                  symbol: '₾'   },
  { code: 'GHS', name: 'Ghanaian Cedi',                  symbol: '₵'   },
  { code: 'GIP', name: 'Gibraltar Pound',                symbol: '£'   },
  { code: 'GMD', name: 'Gambian Dalasi',                 symbol: 'D'   },
  { code: 'GNF', name: 'Guinean Franc',                  symbol: 'Fr'  },
  { code: 'GTQ', name: 'Guatemalan Quetzal',             symbol: 'Q'   },
  { code: 'GYD', name: 'Guyanaese Dollar',               symbol: '$'   },
  { code: 'HKD', name: 'Hong Kong Dollar',               symbol: 'HK$' },
  { code: 'HNL', name: 'Honduran Lempira',               symbol: 'L'   },
  { code: 'HRK', name: 'Croatian Kuna',                  symbol: 'kn'  },
  { code: 'HTG', name: 'Haitian Gourde',                 symbol: 'G'   },
  { code: 'HUF', name: 'Hungarian Forint',               symbol: 'Ft'  },
  { code: 'IDR', name: 'Indonesian Rupiah',              symbol: 'Rp'  },
  { code: 'ILS', name: 'Israeli New Shekel',             symbol: '₪'   },
  { code: 'INR', name: 'Indian Rupee',                   symbol: '₹'   },
  { code: 'IQD', name: 'Iraqi Dinar',                    symbol: 'ع.د' },
  { code: 'IRR', name: 'Iranian Rial',                   symbol: '﷼'   },
  { code: 'ISK', name: 'Icelandic Króna',                symbol: 'kr'  },
  { code: 'JMD', name: 'Jamaican Dollar',                symbol: 'J$'  },
  { code: 'JOD', name: 'Jordanian Dinar',                symbol: 'JD'  },
  { code: 'JPY', name: 'Japanese Yen',                   symbol: '¥'   },
  { code: 'KES', name: 'Kenyan Shilling',                symbol: 'KSh' },
  { code: 'KGS', name: 'Kyrgystani Som',                 symbol: 'с'   },
  { code: 'KHR', name: 'Cambodian Riel',                 symbol: '៛'   },
  { code: 'KMF', name: 'Comorian Franc',                 symbol: 'Fr'  },
  { code: 'KPW', name: 'North Korean Won',               symbol: '₩'   },
  { code: 'KRW', name: 'South Korean Won',               symbol: '₩'   },
  { code: 'KWD', name: 'Kuwaiti Dinar',                  symbol: 'KD'  },
  { code: 'KYD', name: 'Cayman Islands Dollar',          symbol: '$'   },
  { code: 'KZT', name: 'Kazakhstani Tenge',              symbol: '₸'   },
  { code: 'LAK', name: 'Laotian Kip',                    symbol: '₭'   },
  { code: 'LBP', name: 'Lebanese Pound',                 symbol: 'L£'  },
  { code: 'LKR', name: 'Sri Lankan Rupee',               symbol: '₨'   },
  { code: 'LRD', name: 'Liberian Dollar',                symbol: '$'   },
  { code: 'LSL', name: 'Lesotho Loti',                   symbol: 'L'   },
  { code: 'LYD', name: 'Libyan Dinar',                   symbol: 'LD'  },
  { code: 'MAD', name: 'Moroccan Dirham',                symbol: 'MAD' },
  { code: 'MDL', name: 'Moldovan Leu',                   symbol: 'L'   },
  { code: 'MGA', name: 'Malagasy Ariary',                symbol: 'Ar'  },
  { code: 'MKD', name: 'Macedonian Denar',               symbol: 'ден' },
  { code: 'MMK', name: 'Myanmar Kyat',                   symbol: 'K'   },
  { code: 'MNT', name: 'Mongolian Tugrik',               symbol: '₮'   },
  { code: 'MOP', name: 'Macanese Pataca',                symbol: 'P'   },
  { code: 'MRU', name: 'Mauritanian Ouguiya',            symbol: 'UM'  },
  { code: 'MUR', name: 'Mauritian Rupee',                symbol: '₨'   },
  { code: 'MVR', name: 'Maldivian Rufiyaa',              symbol: 'Rf'  },
  { code: 'MWK', name: 'Malawian Kwacha',                symbol: 'MK'  },
  { code: 'MXN', name: 'Mexican Peso',                   symbol: '$'   },
  { code: 'MYR', name: 'Malaysian Ringgit',              symbol: 'RM'  },
  { code: 'MZN', name: 'Mozambican Metical',             symbol: 'MT'  },
  { code: 'NAD', name: 'Namibian Dollar',                symbol: '$'   },
  { code: 'NGN', name: 'Nigerian Naira',                 symbol: '₦'   },
  { code: 'NIO', name: 'Nicaraguan Córdoba',             symbol: 'C$'  },
  { code: 'NOK', name: 'Norwegian Krone',                symbol: 'kr'  },
  { code: 'NPR', name: 'Nepalese Rupee',                 symbol: '₨'   },
  { code: 'NZD', name: 'New Zealand Dollar',             symbol: 'NZ$' },
  { code: 'OMR', name: 'Omani Rial',                     symbol: '﷼'   },
  { code: 'PAB', name: 'Panamanian Balboa',              symbol: 'B/.' },
  { code: 'PEN', name: 'Peruvian Sol',                   symbol: 'S/.' },
  { code: 'PGK', name: 'Papua New Guinean Kina',         symbol: 'K'   },
  { code: 'PHP', name: 'Philippine Peso',                symbol: '₱'   },
  { code: 'PKR', name: 'Pakistani Rupee',                symbol: '₨'   },
  { code: 'PLN', name: 'Polish Zloty',                   symbol: 'zł'  },
  { code: 'PYG', name: 'Paraguayan Guarani',             symbol: '₲'   },
  { code: 'QAR', name: 'Qatari Rial',                    symbol: '﷼'   },
  { code: 'RON', name: 'Romanian Leu',                   symbol: 'lei' },
  { code: 'RSD', name: 'Serbian Dinar',                  symbol: 'din' },
  { code: 'RUB', name: 'Russian Ruble',                  symbol: '₽'   },
  { code: 'RWF', name: 'Rwandan Franc',                  symbol: 'Fr'  },
  { code: 'SAR', name: 'Saudi Riyal',                    symbol: '﷼'   },
  { code: 'SBD', name: 'Solomon Islands Dollar',         symbol: '$'   },
  { code: 'SCR', name: 'Seychellois Rupee',              symbol: '₨'   },
  { code: 'SDG', name: 'Sudanese Pound',                 symbol: '£'   },
  { code: 'SEK', name: 'Swedish Krona',                  symbol: 'kr'  },
  { code: 'SGD', name: 'Singapore Dollar',               symbol: 'S$'  },
  { code: 'SHP', name: 'St. Helena Pound',               symbol: '£'   },
  { code: 'SLL', name: 'Sierra Leonean Leone',           symbol: 'Le'  },
  { code: 'SOS', name: 'Somali Shilling',                symbol: 'Sh'  },
  { code: 'SRD', name: 'Surinamese Dollar',              symbol: '$'   },
  { code: 'STN', name: 'São Tomé & Príncipe Dobra',      symbol: 'Db'  },
  { code: 'SVC', name: 'Salvadoran Colón',               symbol: '₡'   },
  { code: 'SYP', name: 'Syrian Pound',                   symbol: '£'   },
  { code: 'SZL', name: 'Swazi Lilangeni',                symbol: 'L'   },
  { code: 'THB', name: 'Thai Baht',                      symbol: '฿'   },
  { code: 'TJS', name: 'Tajikistani Somoni',             symbol: 'SM'  },
  { code: 'TMT', name: 'Turkmenistani Manat',            symbol: 'T'   },
  { code: 'TND', name: 'Tunisian Dinar',                 symbol: 'DT'  },
  { code: 'TOP', name: "Tongan Pa'anga",                 symbol: 'T$'  },
  { code: 'TRY', name: 'Turkish Lira',                   symbol: '₺'   },
  { code: 'TTD', name: 'Trinidad & Tobago Dollar',       symbol: 'TT$' },
  { code: 'TWD', name: 'New Taiwan Dollar',              symbol: 'NT$' },
  { code: 'TZS', name: 'Tanzanian Shilling',             symbol: 'Sh'  },
  { code: 'UAH', name: 'Ukrainian Hryvnia',              symbol: '₴'   },
  { code: 'UGX', name: 'Ugandan Shilling',               symbol: 'Sh'  },
  { code: 'USD', name: 'US Dollar',                      symbol: '$'   },
  { code: 'UYU', name: 'Uruguayan Peso',                 symbol: '$U'  },
  { code: 'UZS', name: 'Uzbekistani Som',                symbol: 'so\'m'},
  { code: 'VES', name: 'Venezuelan Bolívar',             symbol: 'Bs.S'},
  { code: 'VND', name: 'Vietnamese Dong',                symbol: '₫'   },
  { code: 'VUV', name: 'Vanuatu Vatu',                   symbol: 'Vt'  },
  { code: 'WST', name: 'Samoan Tala',                    symbol: 'T'   },
  { code: 'XAF', name: 'Central African CFA Franc',      symbol: 'Fr'  },
  { code: 'XCD', name: 'East Caribbean Dollar',          symbol: '$'   },
  { code: 'XOF', name: 'West African CFA Franc',         symbol: 'Fr'  },
  { code: 'XPF', name: 'CFP Franc',                      symbol: 'Fr'  },
  { code: 'YER', name: 'Yemeni Rial',                    symbol: '﷼'   },
  { code: 'ZAR', name: 'South African Rand',             symbol: 'R'   },
  { code: 'ZMW', name: 'Zambian Kwacha',                 symbol: 'ZK'  },
  { code: 'ZWL', name: 'Zimbabwean Dollar',              symbol: '$'   },
];

/** Fast lookup map: code → currency object */
const CURRENCY_MAP = Object.fromEntries(CURRENCIES.map(c => [c.code, c]));

/**
 * Set of symbols shared by more than one currency.
 * For these, getCurrencyDisplay appends the ISO code to avoid ambiguity
 * (e.g. "$ USD" instead of just "$").
 */
const SHARED_SYMBOLS = new Set(
  Object.entries(
    CURRENCIES.reduce((acc, c) => {
      acc[c.symbol] = (acc[c.symbol] || 0) + 1;
      return acc;
    }, {})
  )
  .filter(([, count]) => count > 1)
  .map(([sym]) => sym)
);

/**
 * Returns the display string for a currency code.
 *
 * - Unique symbol  → symbol only          e.g. '₹'  (INR), '€' (EUR)
 * - Shared symbol  → symbol + ' ' + code  e.g. '$ USD', '¥ JPY', '£ GBP'
 * - Unknown code   → code itself          e.g. 'XYZ'
 *
 * @param {string} code - ISO 4217 code, e.g. 'INR', 'USD'
 * @returns {string}
 */
export function getCurrencyDisplay(code) {
  const currency = CURRENCY_MAP[code || DEFAULT_CURRENCY] || CURRENCY_MAP[DEFAULT_CURRENCY];
  if (!currency) return code || DEFAULT_CURRENCY;
  const { symbol } = currency;
  return SHARED_SYMBOLS.has(symbol) ? `${symbol} ${currency.code}` : symbol;
}

/**
 * Filters currencies by a search term (matches code or name, case-insensitive).
 * @param {string} query
 * @returns {Array}
 */
export function searchCurrencies(query) {
  if (!query) return CURRENCIES;
  const q = query.toLowerCase();
  return CURRENCIES.filter(
    c => c.code.toLowerCase().includes(q) || c.name.toLowerCase().includes(q)
  );
}
